<div class="modal">
  <div class="container model-container {{context.customClass}}" (keypress.esc)="onKeydown($event)">
    <div class="modal-header">
      <h4 class="modal-heading">{{context.title}}</h4>
      <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
        alt="Close Icon">
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <div class="id-section">
          <p class="id">Tracking ID:</p>
          <p class="text-bold tracking-number">{{context.trackingNumber}}</p>
          <img class="copy-icon" src="assets/icon/primary-copy.svg" alt="copy" (click)="copyId()" height="24" width="24">
        </div>
        <div class="dates" *ngFor="let dateStatus of trackingStatuses">
          <ng-container *ngFor="let step of dateStatus; let j = index">
            <div class="date-title" *ngIf="j === 0">
              <p class="smaller title">{{step?.eventDate | date}}</p>
            </div>
            <div class="details" [class.first]="j === 0">
              <div class="step">
                <p class="smallest time">{{step?.eventTime | date: 'h:mm a'}}</p>
                <div class="time-details">
                  <p class="smallest text-bold status">{{step?.event}}</p>
                  <p class="smallest location">{{step?.eventCity}} {{step?.eventState ? ',' + step?.eventState : ''}}
                    {{step?.eventCountry}}</p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <p class="last-note smaller">Times are shown in the local timezone.</p>
      </div>
    </div>
  </div>
</div>
